// @flow
import { createAction } from 'redux-actions';
import { payloadCreator } from '@ux/fabric';
import * as r from 'ramda';

// Action Types
const prefix = '@@dst/M_';
export const SEEDED = `${prefix}_SEEDED`;
export const LOCALE_LOADED = `${prefix}_LOCALE_LOADED`;
export const BROWSER_SESSION_LOADED = `${prefix}_BROWSER_SESSION_LOADED`;

export const SEARCHING = `${prefix}_SEARCHING`;
export const SEARCH_RESULTS_RECEIVED = `${prefix}_SEARCH_RESULTS_RECEIVED`;
export const SEARCH_FAILURE = `${prefix}_SEARCH_FAILURE`;

export const VERIFYING = `${prefix}_VERIFYING`;
export const VERIFIED = `${prefix}VERIFIED`;
export const VERIFYING_COMPLETE = `${prefix}_VERIFYING_COMPLETE`;
export const VERIFYING_FAILED = `${prefix}VERIFYING_FAILED`;

export const FILTERING = `${prefix}_FILTERING`;
export const FILTERED = `${prefix}_FILTERED`;

export const PURCHASING_BUNDLE = `${prefix}PURCHASING_BUNDLE`;
export const BUNDLE_PURCHASED = `${prefix}_BUNDLE_PURCHASED`;
export const BUNDLE_FAILED = `${prefix}BUNDLE_FAILED`;

export const EMIT_SUCCESS = `${prefix}EMIT_SUCCESS`;
export const EMIT_FAILED = `${prefix}EMIT_FAILED`;

export const DOMAIN_NEGOTIATED = `${prefix}_DOMAIN_NEGOTIATED`;

// Action Creators
export const seeded = createAction(SEEDED, (
  query,
  brandId,
  exchangeRate,
  minTldLength,
  bundle,
  features,
  asyncHooks,
  usePPE,
  includeTax,
  unspunTlds,
  filters,
) => ({
  query,
  brandId,
  exchangeRate,
  minTldLength,
  bundle,
  features,
  asyncHooks,
  usePPE,
  includeTax,
  unspunTlds,
  filters,
}));
export const localeLoaded = createAction(LOCALE_LOADED, () => ({}));
export const browserSessionLoaded = createAction(
  BROWSER_SESSION_LOADED,
  payloadCreator([ 'browserSession' ])
);
export const searching = createAction(SEARCHING, payloadCreator([ 'query' ]));
export const searchResultsReceived = createAction(
  SEARCH_RESULTS_RECEIVED,
  payloadCreator([ 'results' ]),
);
export const searchFailure = createAction(SEARCH_FAILURE, r.identity);

export const verifying = createAction(VERIFYING, payloadCreator([ 'fqdn' ]));
export const verified = createAction(
  VERIFIED,
  payloadCreator([ 'fqdn', 'available' ]),
);
export const verifyingComplete = createAction(
  VERIFYING_COMPLETE,
  payloadCreator([ 'fqdn', 'status' ]),
);
export const verifyingFailed = createAction(
  VERIFYING_FAILED,
  payloadCreator([ 'fqdn' ]),
);

export const filtering = createAction(FILTERING, payloadCreator([ 'filters' ]));
export const filtered = createAction(FILTERED, payloadCreator([ 'filters' ]));

export const purchasingBundle = createAction(
  PURCHASING_BUNDLE,
  payloadCreator([ 'fqdn', 'bundles' ]),
);
export const bundlePurchased = createAction(
  BUNDLE_PURCHASED,
  payloadCreator([ 'fqdn', 'bundles' ]),
);
export const bundleFailed = createAction(
  BUNDLE_FAILED,
  payloadCreator([ 'fqdn', 'bundles' ]),
);

export const emitSuccess = createAction(
  EMIT_SUCCESS,
  payloadCreator([ 'hook', 'payload' ]),
);
export const emitFailed = createAction(
  EMIT_FAILED,
  payloadCreator([ 'hook', 'payload' ]),
);

export const domainNegotiated = createAction(DOMAIN_NEGOTIATED);
